var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24316 0.0683594C8.40135 -0.0245043 8.59784 -0.0225487 8.75488 0.0722656L16.7588 4.90723C16.9084 4.99775 16.9999 5.16009 17 5.33496V15.0254C16.9999 15.2089 16.8987 15.3776 16.7373 15.4648L8.97559 19.6611C8.67884 19.8216 8.32116 19.8216 8.02441 19.6611L0.262695 15.4648C0.101311 15.3776 0.000139118 15.2089 0 15.0254V5.49023C0 5.13589 0.187756 4.80761 0.493164 4.62793L8.24316 0.0683594ZM6.83887 11.6172L4.83789 9.61621L4.61328 9.39062L4.38867 9.61621L3.64648 10.3574L3.42188 10.583L6.83887 14L13.4229 7.41602L13.6484 7.19141L13.4229 6.9668L12.6816 6.22461L12.4561 6L6.83887 11.6172ZM13.1982 7.19141L6.83887 13.5508L6.83789 13.5498L13.1963 7.19141L12.4551 6.4502L12.4561 6.44922L13.1982 7.19141ZM6.83789 12.0654L6.83691 12.0664L4.6123 9.8418L4.61328 9.84082L6.83789 12.0654Z",
    fill: "#14AC63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxCreate);
export default __webpack_public_path__ + "static/media/BoxCreate.f768395886b6548ea20973a9eaf34cbf.svg";
export { ForwardRef as ReactComponent };